/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../eigen_lcm/Vector3d";

export const protobufPackage = "body";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PosYawPb {
  utime: number;
  yaw: number;
  position: Vector3dPb | undefined;
}

function createBasePosYawPb(): PosYawPb {
  return { utime: 0, yaw: 0, position: undefined };
}

export const PosYawPb = {
  encode(message: PosYawPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.yaw !== 0) {
      writer.uint32(17).double(message.yaw);
    }
    if (message.position !== undefined) {
      Vector3dPb.encode(message.position, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PosYawPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePosYawPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.yaw = reader.double();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.position = Vector3dPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PosYawPb {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      yaw: isSet(object.yaw) ? globalThis.Number(object.yaw) : 0,
      position: isSet(object.position) ? Vector3dPb.fromJSON(object.position) : undefined,
    };
  },

  toJSON(message: PosYawPb): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.yaw !== 0) {
      obj.yaw = message.yaw;
    }
    if (message.position !== undefined) {
      obj.position = Vector3dPb.toJSON(message.position);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PosYawPb>, I>>(base?: I): PosYawPb {
    return PosYawPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PosYawPb>, I>>(object: I): PosYawPb {
    const message = createBasePosYawPb();
    message.utime = object.utime ?? 0;
    message.yaw = object.yaw ?? 0;
    message.position = (object.position !== undefined && object.position !== null)
      ? Vector3dPb.fromPartial(object.position)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
